import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          // Bail fast on 4xx — they won't fix themselves.
          if (error && typeof error === 'object' && 'status' in error) {
            const status = (error as { status: unknown }).status;
            if (typeof status === 'number' && status >= 400 && status < 500) return false;
          }
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
